<div class="flex flex-col relative h-full overflow-y-auto overflow-x-hidden">
    <div class="bg-neutral-lightest py-[6px] gap-5 flex justify-between items-center">
        <k-button type="transparent" [padding]="0" (click)="toggleUnread()">
            {{ (unread() ? 'CLINIC_MESSAGE_NOTIFICATION.VIEW_ALL' : 'CLINIC_MESSAGE_NOTIFICATION.VIEW_UNREAD') | translate }}
        </k-button>

        <k-button type="transparent" [padding]="0" (click)="markRead()" [loading]="isLoadingRead()">
            {{ 'CLINIC_MESSAGE_NOTIFICATION.MAKE_AS_READ' | translate }}
        </k-button>
    </div>

    @if (isEmpty()) {
        <k-empty
            [size]="80"
            class="m-auto"
            [description]="'CLINIC_MESSAGE_NOTIFICATION.EMPTY' | translate"
            customPaddingBottom="6px"
            imageUrl="/assets/images/notifications/message-empty.svg"
        />
    } @else {
        @for (order of viewNotifications(); track order.key; let isLast = $last) {
            <div class="px-[16px] py-[14px] flex items-start gap-[6px]">
                <ngx-avatars [src]="order.customerAvatarUrl" [name]="order.customerName" [initialsSize]="2" [size]="36" />

                <div class="w-[calc(100%-46px)] flex flex-col gap-[2px]">
                    <div class="flex justify-between items-center gap-1 overflow-hidden text-ellipsis">
                        <span class="font-medium text-[14px] leading-[16px] text-kiwid-text-main-darkest truncate">
                            {{ order.customerName }}
                        </span>

                        <span class="font-regular text-[12px] leading-[16px] text-kiwid-neutral-darker flex-shrink-0">
                            {{ order.date }}
                        </span>
                    </div>
                    <div class="flex justify-between items-center gap-1">
                        <span
                            class="font-medium text-[11px] leading-[16px] text-neutral-default truncate"
                            [class.text-neutral-lighter]="!order.hasPatient"
                            [class.text-neutral-darker]="order.hasPatient"
                        >
                            {{ order.patientName }}
                        </span>
                        <k-label
                            iconAlign="left"
                            [type]="order.labelStyle.type"
                            [backgroundColor]="order.labelStyle.backgroundColor"
                            [borderColor]="order.labelStyle.borderColor"
                            [color]="order.labelStyle.textColor"
                        >
                            <div class="flex items-center gap-1">
                                {{ order.orderNumber }}

                                @if (order.orderRemake.enable) {
                                    <div
                                        class="flex-shrink-0 w-[12px] h-[12px] rounded-full text-center text-white !leading-[12px] font-bold text-[9px] my-auto uppercase {{
                                            order.orderRemake.classes
                                        }}"
                                        ngxTippy
                                        [tippyProps]="{
                                            theme: 'kiwid',
                                            allowHTML: true,
                                            placement: 'top',
                                            maxWidth: 280,
                                            content: order.orderRemake.content,
                                        }"
                                    >
                                        {{ order.orderRemake.text }}
                                    </div>
                                }
                            </div>
                        </k-label>
                    </div>
                    <div class="gap-1 flex justify-between items-center overflow-hidden text-ellipsis">
                        <span class="font-regular text-neutral-default text-[12px] leading-[15px] truncate" [innerHTML]="order.message"></span>
                        @if (order.badge > 0) {
                            <span
                                class="flex-shrink-0 bg-brand-main-darker w-[15px] h-[15px] rounded-[25px] flex justify-center items-center text-center text-white font-semi-bold text-[9px] leading-[11px]"
                            >
                                {{ order.badge }}
                            </span>
                        }
                    </div>
                    <div class="flex pt-[6px]">
                        <a [routerLink]="order.routerLink" [queryParams]="order.queryParams" (click)="close()">
                            <span class="font-bold text-[11px] leading-[13px] hover:cursor-pointer no-underline">
                                {{ 'CLINIC_MESSAGE_NOTIFICATION.GO_TO_CHAT' | translate }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            @if (!isLast) {
                <hr class="m-0 border-none h-[1px] bg-neutral-lightest" />
            }
        }

        <div class="flex flex-col relative">
            @if (!isLoadingPage()) {
                <div scrollView (elementVisible)="nextPage()"></div>
            } @else {
                <div class="flex justify-center items-center p-5">
                    <mat-spinner diameter="20" strokeWidth="1" />
                </div>
            }
        </div>
    }
</div>
